import Vue from 'vue';
import App from '@/App.vue';
import router from '@/router';
import store from '@/store';
import axios from 'axios';
import VueAxios from 'vue-axios';
import UtilsService from '@/core/services/utils.service';
import dayjs from 'dayjs';

import '@/styles/iconFonts/style.css';
import '@/assets/external-fonts/style.css';

Vue.config.productionTip = false;

Vue.config.silent = true

const token = localStorage.getItem('user-token');
if (token) {
  const tokenExpirationDate = localStorage.getItem('token-expiration-date');
  if (tokenExpirationDate) {
    const dayjsTokenExpiration = dayjs(tokenExpirationDate);
    const expirationDate = dayjs();
    if (expirationDate >= dayjsTokenExpiration) {
      store.dispatch('authLogout');
    } else {
      axios.defaults.headers.common.Authorization = token;
    }
  }
  const openNavbarString = localStorage.getItem('open-navbar');
  if (openNavbarString !== null) {
    const openNavbar = openNavbarString === 'true';
    store.dispatch('setOpenNavbar', openNavbar);
  }
}

Vue.use(VueAxios, axios);

import * as Sentry from '@sentry/browser';

if (!UtilsService.inDebug()) {
  Sentry.init({
    dsn: 'https://fd519075cbda4fa9b55aa85cd0625019@sentry.io/1294867',
    integrations: [new Sentry.Integrations.Vue({ Vue })],
  });
}

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
